module.exports = __webpack_public_path__ + "img/Beginner-6.ea67c3dd.png";